import { jsx as _jsx } from "react/jsx-runtime";
import AnimatedLink from "@components/link/AnimatedLink";
const LocalNavigationItem = ({ link: { title, url } }) => _jsx(AnimatedLink, { label: title, url: url, color: "charcoal", hoverColor: "bdo-red" });
export default LocalNavigationItem;
